import { render, staticRenderFns } from "./QuotationButtons.vue?vue&type=template&id=1f371c14&scoped=true&lang=html"
import script from "./QuotationButtons.vue?vue&type=script&lang=js"
export * from "./QuotationButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f371c14",
  null
  
)

export default component.exports